import { Airplane, Send } from 'react-bootstrap-icons';
import './CommentBox.css';
import { IoAirplane, IoSend } from 'react-icons/io5';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleTask } from '../../../../redux/TaskReducer/action';
import { getAllComments } from '../../../../utils/taskUtils';
import { isAuthorised } from '../../../../utils/common';
import { TASK_MANAGEMENT_COMPONENTS } from '../../../../config/task_management';
import { getAuthToken } from "../../../../utils/auth";

const CommentBox = ({ subtask }) => {
  const { officerProfile } = useSelector((store) => {
    return {
        officerProfile: store.UserReducer.officerProfile
    }
  });

  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || JSON.parse(localStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  const [commentText, setCommentText] = useState("");
  const [loadPrevComments, setLoadPrevComments] = useState(false);

  const [allComments, setAllComments] = useState(subtask?.comments);

  const dispatch = useDispatch();

  const handleSubtaskComment = async () => {
    if (!authToken) {
      toast.error(`Invalid or missing token.`);
      return;
    }

    let headers = {
      'Authorization': `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }

    let commentObj = {
      sub_task_id: subtask?.sub_task_id,
      comment_type: "COMMENT",
      is_internal: true,
      comment_text: commentText
    }

    try {
      let response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/task/comment`, commentObj, { headers });

      if(response?.data?.data){
        toast.success(`Comment added successfully.`);
        // dispatch(getSingleTask(subtask?.parent_task_id));
        let updatedComments = await getAllComments({ sub_task_id: subtask?.sub_task_id });

        setAllComments(updatedComments);
      }
    }
    catch (error) {
      toast.error("Error in adding comment", error);
      setAllComments([]);
    }
    finally {
      setCommentText("");
    }
  }

  const latestComment =  allComments
                            ?.slice() // prevent mutating original array
                            ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                            ?.at(0);

  return (
    <div className='comment-box-container'>
      <div className='comment-box-header'>
        <div className='comment-topic'>
          <p>Comments: </p>
          {
            loadPrevComments ? 
            allComments?.map((comment) => (
              <>
                <span className='comment-item'>
                  <span className='comment-user'>
                    {`${comment?.creator?.first_name}${comment?.creator?.middle_name ? ` ${comment?.creator?.middle_name}` : ""}${comment?.creator?.last_name ? ` ${comment?.creator?.last_name}` : ""}`}
                  </span> : {comment?.comment_text}
                </span>
                {/* <br /> */}
              </>
            )) : 
            <span className='comment-item'>
              {
                latestComment && (<>
                  <span className='comment-user'>
                    {(latestComment ? [
                        latestComment.creator?.first_name,
                        latestComment.creator?.middle_name,
                        latestComment.creator?.last_name,
                      ]
                        .filter(Boolean)
                        .join(" ")
                    : "")}
                  </span> : {latestComment?.comment_text}
                </>)
              }
            </span>
          }
        </div>
        <div>
          <p 
            className='load-comments-text'
            onClick={() => {
              setLoadPrevComments(prev => !prev);
            }}
          >
            {!loadPrevComments ? "Load Previous Comments" : "Hide Previous Comments"}
          </p>
        </div>
      </div>
      {isAuthorised(
        officerProfile,
        TASK_MANAGEMENT_COMPONENTS?.allow_comments
      ) && <div className="comment-box">
        {/* <p>{subtask.user_comment}</p> */}
        <input 
          name='commentText'
          type='text'
          placeholder="Add Comment here..." 
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
        />
        <div className="send-icon"
          onClick={handleSubtaskComment}
        >
          <IoSend color={"var(--text-muted)"} />
        </div>
      </div>}
    </div>
  );
}

export default CommentBox;